import axios from 'axios';

import { Id, PagedParams, PagedResponse, getData } from '@feature/utils';

import { Dictionary, DictionaryRequest } from './DictionaryTypes';

export function getPaged(params: PagedParams) {
  return axios
    .get<PagedResponse<Dictionary>>('/author/dictionaries/paged', {
      params,
    })
    .then(getData);
}

export function get(id: Id) {
  return axios.get<Dictionary>(`/author/dictionaries/${id}`).then(getData);
}

export function edit(id: Id, request: DictionaryRequest) {
  return axios.put<Dictionary>(`/author/dictionaries/${id}`, request).then(getData);
}

export function create(request: DictionaryRequest) {
  return axios.post<Dictionary>(`/author/dictionaries`, request).then(getData);
}

export function deleteById(id: Id) {
  return axios.delete<unknown>(`/author/dictionaries/${id}`).then(getData);
}
